import { render } from "./WorkflowHistory.vue?vue&type=template&id=0f93fe16&scoped=true"
import script from "./WorkflowHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowHistory.vue?vue&type=script&lang=js"

import "./WorkflowHistory.vue?vue&type=style&index=0&id=0f93fe16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f93fe16"]])

export default __exports__